import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { useTranslation } from 'react-i18next'

import ColorPicker from 'components/ColorPicker/ColorPicker'

import invertColor from '../../../../../util/invertColor'

import BlockTitle from '../BlockTitle/BlockTitle'

import { CARD_BACKGROUND_COLOR } from './constants'

import MulticolorWheelEmpty from './svg/MulticolorWheelEmpty'
import MulticolorWheelFilled from './svg/MulticolorWheelFilled'

import styles from './ColorBlock.module.scss'

const ColorBlock = ({ backgroundColor, onChange }) => {
    const { t } = useTranslation()
    const [isUseMulticolor, setIsUseMulticolor] = useState(false)

    useEffect(() => {
        setIsUseMulticolor(!CARD_BACKGROUND_COLOR.find(color => color.toLowerCase() === backgroundColor.toLowerCase()))
    }, [backgroundColor])

    return (
        <>
            <BlockTitle text={t('Card color')} />
            <ul className={styles.list}>
                {CARD_BACKGROUND_COLOR.map(color => (
                    <li
                        key={color}
                        className={classNames(styles.item, {
                            [styles.isSelectedItem]: backgroundColor.toLowerCase() === color.toLowerCase(),
                        })}
                        style={{ backgroundColor: color, color: invertColor(color, true) }}
                        onClick={() => onChange(color)}
                    />
                ))}
                <ColorPicker value={backgroundColor} onChange={v => onChange(v)}>
                    <li
                        className={classNames(styles.item, styles.isMultiColorItem, {
                            [styles.isSelectedItem]: isUseMulticolor,
                        })}
                    >
                        {isUseMulticolor ? (
                            <MulticolorWheelFilled
                                backgroundColor={backgroundColor}
                                checkColor={invertColor(backgroundColor, true)}
                            />
                        ) : (
                            <MulticolorWheelEmpty />
                        )}
                    </li>
                </ColorPicker>
            </ul>
        </>
    )
}

export default ColorBlock
